export default __webpack_public_path__ + "static/media/datajolt-icon.a238ecb2.svg";